import { get, once } from 'lodash';
import { hosts, brightcove } from 'settings';
import { assetSrc } from 'utils';
import uuid from 'uuid';
import $ from 'jquery';

const { accountId, playerId } = brightcove;
export const script = {
  uri: `//players.brightcove.net/${accountId}/${playerId}_default/index.min.js`,
  isLoaded: false,
  isLoading: false,
};

export const VideoPlayer = {
  bindings: {
    autoplay: '<',
    index: '<',
    poster: '<',
    videoId: '<',
    onLoad: '&',
  },

  template: `
    <div class="video-player">
      <video class="video-js"
        id="{{$ctrl.videoPlayerId}}"
        data-account="${accountId}"
        data-player="${playerId}"
        data-embed="default"
        playsinline
        controls>
      </video>
    </div>`,

  controller($interval, $timeout, $window) {
    'ngInject';

    return {
      $onInit() {
        this.videoPlayerId = uuid.v4();
      },

      $onChanges(changes = {}) {
        const { currentValue, previousValue } = changes.videoId;

        if (currentValue && currentValue !== previousValue) {
          this.initPlayer();
        }
      },

      $onDestroy() {
        script.isLoaded = false;
        script.isLoading = false;

        if (this.player) {
          this.removeListeners();
          this.player.dispose();
        }
      },

      initPlayer() {
        if (script.isLoading || script.isLoaded) {
          const interval = $interval(() => {
            if (script.isLoaded) {
              this.setPlayer();
              $interval.cancel(interval);
            }
          }, 100);
        } else {
          this.loadScript();
        }
      },

      loadScript() {
        if (!script.isLoading) {
          script.isLoading = true;

          return $.getScript(script.uri).then(() => {
            script.isLoaded = true;
            this.setPlayer();
          });
        }
      },

      setPlayer() {
        this.player = $window.videojs(this.videoPlayerId);
        this.player.controlBar.hide();
        this.player.ready(() => this.onReady());
      },

      setPosterImage(poster) {
        const src = assetSrc(poster);

        // Set poster if the image loads successfully
        $('<img>')
          .prop('src', src)
          .on('load', () => this.player.posterImage.setSrc(src));
      },

      onReady() {
        this.addListeners();
        this.player.catalog.getVideo(this.videoId, (error, response) =>
          this.onGetVideo(response)
        );
      },

      onGetVideo(response) {
        this.player.catalog.load(response);

        if (this.poster) {
          this.setPosterImage(this.poster);
        }

        if (this.onLoad) {
          this.onLoad({ player: this.player });
        }

        if (this.autoplay) {
          $timeout(() => {
            const videoPromise = this.player.play();

            // Shut the error messages up.
            if (videoPromise && videoPromise.catch) {
              videoPromise.catch(() => {});
            }
          });
        }
      },

      onEnded() {
        if (this.player) {
          this.removeListeners();
        }
      },

      onError() {
        const { code } = this.player.error();

        // Filter out videos of the type that errored and re-load.
        if (code === 4) {
          const sources = this.player.mediainfo.sources.filter(
            ({ type }) => type !== this.player.currentType()
          );

          this.player.src(sources);
          this.player.load();
        }
      },

      onPlay() {
        this.player.controlBar.show();
      },

      addListeners() {
        this.player.on('ended', () => this.onEnded());
        this.player.on('error', () => this.onError());
        this.player.on('play', () => this.onPlay());
      },

      removeListeners() {
        this.player.off('ended');
        this.player.off('error');
        this.player.off('play');
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Video/VideoPlayer.js